import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { BREAKPOINTS } from "@onelogin/react-components";

const SplitScreenWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  overflow: hidden;
  width: 100%;

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    margin: 0px;
    border: 0px;
    order: 2; //just to make it better readable
  }
`;

const SecureNotesDisabled = ({ errorMessage }) => (
  <SplitScreenWrapper>
    {/* <p>{errorMessage}</p> */}
    <FormattedMessage id={errorMessage} defaultMessage={errorMessage} />
  </SplitScreenWrapper>
);

SecureNotesDisabled.propTypes = {
  errorMessage: PropTypes.string.isRequired
};

export default SecureNotesDisabled;
